import {
  ActionReducer,
  ActionReducerMap,
  createAction,
  createFeatureSelector,
  createSelector,
  MetaReducer
} from '@ngrx/store';
import { environment } from '../../environments/environment';

export interface AppState {
}

export const reducers: ActionReducerMap<AppState> = {

};


export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [clearState, exceptionHandler] : [clearState, exceptionHandler];


export function exceptionHandler(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    try {
      return reducer(state, action);
    } catch (e: any) {
      console.log(e);
      console.log(e.stack);
    }
  };
}



export enum GlobalActionTypes {
  LOGOUT = '[Login] Logout'
};

export const GlobalActions = {
  logout: createAction(GlobalActionTypes.LOGOUT)
}

export function clearState(reducer: (s: any, a: any) => any) {
  return function (state: any, action: any) {
    if (action.type === GlobalActionTypes.LOGOUT) {
      state = {};
    }
    return reducer(state, action);
  };
}